export function fetchNot() {
  return { type: "FETCH_NOT" };
}
